import React, { useState, useEffect, useCallback } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import Urls from "../../../api/endpoints";
import {
  ErrorHandling,
  ErrorHandlingAPI,
  DateToPersianNumber,
} from "../../../functions/index";
import FormTexts from "../../../constants/forms";
import { formsButtonType, NoteType } from "../../../enums/index";
import Constants from "../../../constants/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { ErrorToast } from "../../../shared/index";

const Notes = (props) => {
  const [noteList, setNoteList] = useState(null);
  const [loading, setLoading] = useState(true);
  const [btn, setBtn] = useState(false);
  const [showSpinner, setShowSpinner] = useState(false);
  const [note, setNote] = useState("");
  const [mountNote, setMountNote] = useState(true);

  const setPageData = useCallback(() => {
    fetch(Urls.getUserNotes(props.userId), {
      method: "Get",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + props.token,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        data?.notes?.sort(function (a, b) {
          return new Date(b.createDate) - new Date(a.createDate);
        });
        setNoteList(data);
        setLoading(false);
      })
      .catch((error) => {
        ErrorHandling(error, "search error", setLoading);
      });
  }, [props]);

  const setUserNotes = (e) => {
    e.preventDefault();
    if (note !== "") {
      setShowSpinner(true);
      setBtn(true);
      fetch(Urls.setUserNotes(props.userId, note), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + props.token,
        },
        body: JSON.stringify({ note: note }),
      })
        .then((response) => response.json())
        .then((data) => {
          setShowSpinner(false);
          setBtn(false);
          setPageData();
          setNote("");
          if (!data.Success) ErrorHandlingAPI(data);
        })
        .catch((error) => {
          setShowSpinner(false);
          setBtn(false);
          setPageData();
          setNote("");
          ErrorHandling(error, "accept error");
        });
    } else {
      ErrorToast(Constants.NoteIsEmpty);
    }
  };
  useEffect(() => {
    if (mountNote) {
      setPageData();
    }

    return () => {
      setMountNote(false);
    };
  }, [setPageData]);
  return (
    noteList &&
    !loading && (
      <div className="notes">
        <Form.Control
          className="mb-2"
          onChange={(e) => setNote(e.target.value)}
          placeholder="متن یادداشت"
          value={note}
        />

        {!showSpinner ? (
          <Button
            disabled={btn}
            onClick={(e) => setUserNotes(e)}
            type="submit"
            className="mb-2"
          >
            {FormTexts.Buttons(formsButtonType.AddNote())}
          </Button>
        ) : (
          <Button disabled={btn} type="submit" className="mb-2">
            <FontAwesomeIcon icon={faSpinner} spin />
          </Button>
        )}

        <div className="list">
          {" "}
          {noteList &&
            noteList?.notes?.map((n, i) => (
              <div className="item" key={i}>
                <div className="info-context">
                  <div>
                    {n.type === "Verification" && (
                      <b className="reject-identity">
                        {Constants.RejectIdentity}
                      </b>
                    )}
                    {n.type === "RejectActivation" && (
                      <b className="reject-identity">
                        {Constants.RejectActivationLabel}
                      </b>
                    )}
                    {n.type === "FreePackageCancelled" && (
                      <b className="cancel-free-package">
                        {Constants.FreePackageCancel}
                      </b>
                    )}
                    {n.type === "ChangeAddress" && (
                      <b className="reject-identity">
                        {Constants.ChangeAddress}
                      </b>
                    )}
                    {n.type === "ChangeGender" && (
                      <b className="reject-identity">
                        {Constants.ChangeGender}
                      </b>
                    )}

                    {n.type === "ChangeFirstName" && (
                      <b className="reject-identity">
                        {Constants.ChangeFirstName}
                      </b>
                    )}
                    {n.type === "ChangeLastName" && (
                      <b className="reject-identity">
                        {Constants.ChangeLastName}
                      </b>
                    )}
                    {n.type === "ChangeFatherName" && (
                      <b className="reject-identity">
                        {Constants.ChangeFatherName}
                      </b>
                    )}
                    {n.type === "ChangeBirthDate" && (
                      <b className="reject-identity">
                        {Constants.ChangeBirthDate}
                      </b>
                    )}
                    {n.note}
                  </div>
                  <div className="edit-info-container">
                    <div className="date-container">{DateToPersianNumber(n.persianCreateDate)}</div>
                    <div>
                      {n.userName}
                      {Constants.UnderLine}
                    </div>
                  </div>
                </div>
                <div className="li-divider"></div>
              </div>
            ))}
        </div>
      </div>
    )
  );
};
export default Notes;
